export const validatedAssets = items =>
  items
    .filter(item => item.group && item.quantity)
    .map(item => ({
      group: item.group,
      condition: item.condition,
      quantity: item.quantity,
      id: item.id,
    }));
